import { render, staticRenderFns } from "./InvoiceMessage.vue?vue&type=template&id=778fef96&scoped=true"
import script from "./InvoiceMessage.vue?vue&type=script&lang=js"
export * from "./InvoiceMessage.vue?vue&type=script&lang=js"
import style0 from "./InvoiceMessage.vue?vue&type=style&index=0&id=778fef96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778fef96",
  null
  
)

export default component.exports